import { render, staticRenderFns } from "./OfferAccordion.vue?vue&type=template&id=2decfd8a&scoped=true&"
import script from "./OfferAccordion.vue?vue&type=script&lang=js&"
export * from "./OfferAccordion.vue?vue&type=script&lang=js&"
import style0 from "./OfferAccordion.vue?vue&type=style&index=0&id=2decfd8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2decfd8a",
  null
  
)

export default component.exports